import { useState } from "react";
import type IDrillholesCodeNewFieldProps from "./IDrillholesCodeNewFieldProps";
import styles from "../calculationConstructionNewField.module.scss";
import { Icon } from "@fluentui/react";
import DrillholesCodeNewModal from "./modal/DrillholesCodeNewModal";

const DrillholesCodeNewField: React.FunctionComponent<IDrillholesCodeNewFieldProps> = ({
    label,
    selectedMast,
    calculationId,
    drillholesCode,
}) => {
    const [isOpen, handleOpen] = useState<boolean>(false);

    const closeModal = (): void => {
      handleOpen(false);
    };

    return (
    <div className={styles.valueBox}>
      <div>{`${label}:`} </div>
      <div
        className={[
          styles.value,
          !(drillholesCode?.isValid ?? false) && styles.redUnderline,
        ].join(" ")}>
        {drillholesCode?.value}
      </div>
      {(drillholesCode?.drillholes?.length ?? 0) > 0 && (
        <Icon
          className={styles.editIcon}
          iconName="Edit"
          onClick={() => {
            handleOpen(prevState => !prevState);
          }}
        />
      )}

      {isOpen && drillholesCode && (
        <DrillholesCodeNewModal
          calculationId={calculationId}
          drillholesCode={drillholesCode}
          selectedMast={selectedMast}
          isOpen={isOpen}
          closeModal={closeModal}
        />
      )}
    </div>
  );
};

export default DrillholesCodeNewField;